import React from "react";

const trustItems = [
  {
    title: "Coach-Led Practice",
    text: "AI feedback is framed as a training aid, not a replacement for qualified instruction or supervised martial arts coaching.",
  },
  {
    title: "Privacy First",
    text: "Movement analysis is presented with clear consent expectations and avoids implying that webcam footage is shared publicly.",
  },
  {
    title: "Safety Boundaries",
    text: "Students are reminded to train within their current ability, use open space, and pause when technique or fatigue becomes unsafe.",
  },
];

export const TrustSafety: React.FC = () => {
  return (
    <section className="relative z-20 bg-[#f6f1e8] px-4 py-16 text-black sm:px-6 lg:px-10">
      <div className="mx-auto grid max-w-[1180px] gap-10 lg:grid-cols-[0.9fr_1.1fr] lg:items-start">
        <div>
          <p className="font-cinzel text-[12px] font-semibold uppercase tracking-[0.28em] text-[#ec4e20]">
            Trust &amp; Safety
          </p>
          <h2 className="mt-4 max-w-[620px] font-cinzel text-4xl font-bold leading-tight sm:text-5xl">
            Train harder, with clearer guardrails.
          </h2>
          <p className="mt-5 max-w-[560px] font-spectral text-lg leading-8 text-black/75">
            sifu.art uses AI motion review to help students notice form,
            rhythm, and consistency. It does not certify combat readiness,
            replace medical advice, or encourage unsupervised high-risk
            weapon practice.
          </p>
        </div>

        <div className="grid gap-4 sm:grid-cols-3 lg:grid-cols-1">
          {trustItems.map((item) => (
            <div
              key={item.title}
              className="border-2 border-black bg-white p-5 shadow-[8px_8px_0_#000] sm:min-h-[190px] lg:min-h-0"
            >
              <h3 className="font-cinzel text-xl font-bold leading-tight">
                {item.title}
              </h3>
              <p className="mt-3 font-spectral text-base leading-7 text-black/72">
                {item.text}
              </p>
            </div>
          ))}
        </div>
      </div>

      <div className="mx-auto mt-10 grid max-w-[1180px] gap-4 border-2 border-black bg-[#08111d] p-5 text-white shadow-[8px_8px_0_#ec4e20] sm:grid-cols-3">
        <div>
          <p className="font-cinzel text-[11px] uppercase tracking-[0.24em] text-white/55">
            Studio
          </p>
          <p className="mt-2 font-spectral text-lg leading-7">
            81 Hollyberry Trail, North York
          </p>
        </div>
        <div>
          <p className="font-cinzel text-[11px] uppercase tracking-[0.24em] text-white/55">
            Practice Rule
          </p>
          <p className="mt-2 font-spectral text-lg leading-7">
            Clear space, controlled speed, no live contact.
          </p>
        </div>
        <div>
          <p className="font-cinzel text-[11px] uppercase tracking-[0.24em] text-white/55">
            AI Scope
          </p>
          <p className="mt-2 font-spectral text-lg leading-7">
            Form cues and replay review only.
          </p>
        </div>
      </div>
    </section>
  );
};
